<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { TrendingUp, TrendingDown, HelpCircle } from 'lucide-vue-next'

const props = defineProps<{
	title: string
	value: string | number
	change: number
	icon?: any
}>()

const isPositive = computed(() => props.change >= 0)
</script>

<template>
	<div class="border rounded-lg p-4 bg-background hover:shadow-sm transition-shadow">
		<div class="flex justify-between items-start">
			<div>
				<p class="text-sm font-medium text-muted-foreground">{{ title }}</p>
				<h3 class="text-2xl font-bold mt-1">{{ value }}</h3>
			</div>
			<div 
				    v-if="icon" 
				    class="p-2 rounded-lg"
				    :class="isPositive ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'"
				    >
				    <component :is="icon" class="h-5 w-5" />
			</div>
		</div>
		<div class="flex items-center mt-4">
			<div 
		     class="flex items-center text-sm"
		     :class="isPositive ? 'text-green-600' : 'text-red-600'"
		     >
		     <component 
		     :is="isPositive ? TrendingUp : TrendingDown" 
		     class="h-4 w-4 mr-1" 
		     />
		     <span>{{ Math.abs(change) }}%</span>
			</div>
			<p class="text-sm text-muted-foreground ml-2">vs last period</p>
		</div>
	</div>
</template>
